import customDashboardsDateMixin from './customDashboardsDateMixin.js';
import { emitter } from 'shared/helpers/mitt';
import {
  conversationSubmetrics,
  conversationResolutionReasonSubmetrics,
} from 'shared/helpers/CustomDashboardsHelper';

import { DATE_RANGE_OPTIONS } from 'dashboard/routes/dashboard/settings/reports/constants';

export default {
  mixins: [customDashboardsDateMixin],
  computed: {
    canEdit() {
      const onEditPage = this.$route.path.endsWith('/edit');
      const onCreationPage =
        this.$route.path.endsWith('/custom_dashboards') &&
        !this.$route.params?.dashboardId;
      return onEditPage || onCreationPage;
    },
    isSummaryDisplay() {
      return this.display.type === 'summary';
    },
    isDonutDisplay() {
      return this.display.type === 'donut';
    },
    isColumnChartDisplay() {
      return this.display.type === 'column_chart';
    },
    isTableDisplay() {
      return this.display.type === 'table';
    },
    isStaticTextDisplay() {
      return this.display.type === 'static_text';
    },
    isStaticImageDisplay() {
      return this.display.type === 'static_image';
    },
    currentInbox() {
      return this.$store.getters['inboxes/getInbox'](this.inbox.id);
    },
    dateRangeDescription() {
      if (this.selectedDateRange.id === 'CUSTOM_DATE_RANGE') {
        const formatUnixToDate = unixTimestamp =>
          new Date(unixTimestamp * 1000).toLocaleDateString('en-CA'); // Unix to yyyy-mm-dd
        const [from, to] = this.dateRange.range;
        return `${formatUnixToDate(from)}...${formatUnixToDate(to)}`;
      }
      return this.$t(this.selectedDateRange.translationKey);
    },
  },
  mounted() {
    // Estou colocando esse atraso aqui para não fazermos requisições desnecessárias
    // Só faremos requisições se o componente persistir durante o tempo estipulado
    setTimeout(() => {
      this.setInitialData();
      if (!this.canEdit) this.fetchData();
    }, 100);

    this.initializeWidthObserver();
  },

  beforeDestroy() {
    // Turning off observer
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },

  methods: {
    translatedDateRangeOptions() {
      return Object.values(DATE_RANGE_OPTIONS).map(option => ({
        ...option,
        name: this.$t(option.translationKey),
      }));
    },
    translatedSubmetricsOptions() {
      return conversationSubmetrics.map(submetric => {
        const obj = {};
        obj.type = submetric.type;
        obj.title =
          this.$t(submetric.title.i18nKey) + submetric.title.additional;
        return obj;
      });
    },
    translatedConversationResolutionReasonsSubmetricsOptions() {
      return conversationResolutionReasonSubmetrics.map(submetric => {
        const obj = {};
        obj.type = submetric.type;
        obj.title =
          this.$t(submetric.title.i18nKey) + submetric.title.additional;
        return obj;
      });
    },
    openEditModal() {
      emitter.emit('openEditWidgetModal', { id: this.id });
    },

    // Usa ResizeObserver para monitorar mudanças de tamanho no componente
    initializeWidthObserver() {
      this.resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
          this.componentWidth = entry.contentRect.width;
        });
      });
      this.resizeObserver.observe(this.$refs.widget);

      // Setta o valor inicial da largura do componente
      this.$nextTick(() => {
        if (this.$refs.widget) {
          const rect = this.$refs.widget.getBoundingClientRect();
          this.componentWidth = rect.width;
        }
      });
    },
  },
};
